// Path: src/components/admin/AdminPanel.tsx
// feat: Restructure to include a proper Header for the top menu.
// feat: Implement a responsive mobile layout with a hamburger button and Drawer.
// fix: Correctly positions the AdminMenu at the top of the page.
// 06/07/25 12:40 PM +07

import React, { useState } from "react";
import { Layout, Button, Drawer } from "antd";
import { Helmet } from "react-helmet-async";
import AdminMenu from "./AdminMenu";
import AdminRoutes from "./AdminRoutes";
import { MenuOutlined } from "@ant-design/icons";
import styled from "styled-components";

const { Header, Content } = Layout;

const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #3552fc;
  padding: 0 20px;

  .admin-title {
    color: #fff;
    margin: 0;
    font-size: 20px;
  }

  .desktop-menu {
    flex: 1;
    margin-left: 50px;
  }

  @media (max-width: 768px) {
    .desktop-menu {
      display: none;
    }
  }
`;

const MobileMenuButton = styled(Button)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const AdminPanel: React.FC = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Admin Dashboard - OneLightSystem OLS</title>
        <meta name="description" content="Manage users and orders in the OneLightSystem OLS admin dashboard." />
      </Helmet>
      
      <StyledHeader>
        <h3 className="admin-title">OLS Admin</h3>
        <div className="desktop-menu">
          <AdminMenu mode="horizontal" />
        </div>
        <MobileMenuButton
          type="primary"
          icon={<MenuOutlined />}
          onClick={showDrawer}
        />
      </StyledHeader>

      <Drawer
        title="Admin Menu"
        placement="right"
        onClose={closeDrawer}
        visible={drawerVisible}
        bodyStyle={{ padding: 0 }}
      >
        <AdminMenu mode="vertical" onLinkClick={closeDrawer} />
      </Drawer>

      <Layout>
        <Content style={{ margin: "16px" }}>
          <AdminRoutes />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminPanel;  